import Injection = EECore.Injection;
import UpcomingUnavailabilityService from "../../services/upcomingUnavailability/upcomingUnavailabilityService";
import Model from "../models/upcomingUnavailability/upcomingUnavailabilityModel";

@Injection.injectableClass("EEWidget.UpcomingUnavailability")
export default class upcomingUnavailability implements EECore.UI.IWebComponent {

  @Injection.injectableProperty("EEWidget.UpcomingUnavailability", EECore.Registrations.TEMPLATE_FACTORY)
  private templateFactory: EECore.UI.TemplateFactory;

  @Injection.injectableProperty("EEWidget.UpcomingUnavailability", EECore.Registrations.DOCUMENT)
  private document: Document;

  @Injection.injectableProperty("EEWidget.UpcomingUnavailability", "UpcomingUnavailabilityService")
  private upcomingUnavailabilityService: UpcomingUnavailabilityService;

  constructor(templateFactory: EECore.UI.TemplateFactory, document: Document, upcomingUnavailabilityService: UpcomingUnavailabilityService) {
    this.templateFactory = templateFactory;
    this.document = document;
    this.upcomingUnavailabilityService = upcomingUnavailabilityService;
  }

  load(): EECore.Promise<Element, string> {
    return new EECore.Promise<Element, string>((resolve, reject) => {
      this.upcomingUnavailabilityService.getUpcomingUnavailability("EXT2").then((model: Model) => {
        if (!model || !model.message)
          resolve(this.document.createDocumentFragment() as any);
        else
          resolve(this.templateFactory.getTemplate("UpcomingUnavailability", model));
      }).catch(() => {
        reject("Could not get upcoming maintenance.");
      });
    });
  }
}